import * as PIXI from 'pixi.js-legacy'
import DesktopUIScreen from '../../../framework/src/ui/desktop/DesktopUIScreen'
import AbstractUIScreen, {
	STAGE_MODES,
} from '../../../framework/src/ui/screen/AbstractUIScreen'
import { JokerWinCategory } from './JokerWinCategory'
import {
	TTranslateKeys,
	TranslateKeys,
	TranslateService,
} from './TranslateService'
import { textStyle } from './constants/constants'
import { JokerBonusHelpers } from './helpers'
import { IColorScheme } from './interfaces/IColorScheme'

export class JokerBonusWinPopup extends PIXI.Container {
	protected colorScheme: IColorScheme
	protected borderWidth = 2
	bg: PIXI.Sprite
	bgWidth: number
	isMobile: boolean
	bigOffset: number
	smallOffset: number
	constructor(
		jackpot: JokerWinCategory,
		protected screen: AbstractUIScreen,
		protected appScales: [number, number],
		protected translateService: TranslateService
	) {
		super()
		this.isMobile = !(this.screen instanceof DesktopUIScreen)
		this.colorScheme = jackpot.colorScheme
		this.borderWidth = jackpot.borderWidth
		this.bigOffset = this.isMobile ? 15 : 26
		this.smallOffset = 8
		this.bgWidth = this.isMobile
			? (this.screen.getScreenData().mode === STAGE_MODES.PORT
					? window.innerWidth - 10
					: window.innerHeight - 10) / appScales[1]
			: ((jackpot.children[0] as PIXI.Sprite).width *
					//we need to get unscaled width of jackpot, multiply it with its stage scale to get "displayed width" and then divide with tables stage scale to achieve same displayed width of both.
					jackpot.scale.x *
					appScales[0]) /
			  appScales[1]
		//#region text styles
		const labelTextStyle: Partial<PIXI.ITextStyle> = {
			...textStyle,
			fontSize: (this.isMobile ? 16 : 20) / appScales[1],
			letterSpacing: 0.75,
			fill: 0xffffff,
			fillGradientStops: [],
			stroke: null,
			fontFamily: 'Ubuntu-Regular',
			align: 'center',
			wordWrapWidth: this.bgWidth - this.borderWidth * 2,
			wordWrap: true,
		}
		//#endregion

		const highestWinLabel = this.createText(
			this.getText(TranslateKeys.popupText),
			labelTextStyle
		)

		highestWinLabel.position.set(
			this.bgWidth / 2,
			this.smallOffset / (this.isMobile ? appScales[1] : 1)
		)
		//#region background
		this.bg = PIXI.Sprite.from(
			JokerBonusHelpers.linearGradientTexture(
				this.bgWidth,
				highestWinLabel.height * highestWinLabel.scale.y +
					2 * (this.borderWidth / appScales[1]) +
					2 * (this.smallOffset / appScales[1]),
				90,
				this.colorScheme.borderColors,
				this.colorScheme.borderColorStops
			)
		)
		const bg2 = PIXI.Sprite.from(
			JokerBonusHelpers.linearGradientTexture(
				this.bg.width - this.borderWidth / appScales[1],
				this.bg.height - this.borderWidth / appScales[1],
				90,
				this.colorScheme.backgroundColors,
				this.colorScheme.backgroundColorStops
			)
		)
		bg2.x = this.borderWidth / appScales[1] / 2
		bg2.y = this.borderWidth / appScales[1] / 2
		this.bg.addChild(bg2)
		this.addChild(this.bg)
		//#endregion
		bg2.addChild(highestWinLabel)
	}

	protected getText(key: TTranslateKeys): string {
		return this.translateService.translate(key).toUpperCase()
	}

	protected createText(text: string, textStyle: Partial<PIXI.ITextStyle>) {
		const result = new PIXI.Text(text, {
			...textStyle,
		})
		result.anchor.set(0.5, 0)
		return result
	}
}
